module.exports = __webpack_public_path__ + "img/greenPhoto6.b4ac664a.jpg";